import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Notification',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Notification',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Notification',
    column_type: 'datetime',
  },
  actor_type: {
    model_name: 'Notification',
    column_type: 'string',
  },
  actor: {
    model_name: 'Notification',
    column_type: 'belongs_to',
    extra: {
      association_name: 'actor',
      model_name: '',
    },
  },
  actor_id: {
    model_name: 'Notification',
    column_type: 'belongs_to',
    extra: {
      association_name: 'actor',
      model_name: '',
    },
  },
  target_type: {
    model_name: 'Notification',
    column_type: 'string',
  },
  target: {
    model_name: 'Notification',
    column_type: 'belongs_to',
    extra: {
      association_name: 'target',
      model_name: '',
    },
  },
  target_id: {
    model_name: 'Notification',
    column_type: 'belongs_to',
    extra: {
      association_name: 'target',
      model_name: '',
    },
  },
  kind: {
    model_name: 'Notification',
    column_type: 'enum',
  },
  is_read: {
    model_name: 'Notification',
    column_type: 'boolean',
  },
  extra: {
    model_name: 'Notification',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
